export default "__VITE_ASSET__DzhQxfl4__"